import React from "react";
import ModalDisplay from "./ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { tenzero } from "../../constants/Constants";
import { Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
export default function SubmitTestBox(props) {
  let displayValue = "none";
  if (props.display) displayValue = "block";

  function clickNoHandler() {
    props.handler1(false); //calls setSubmitDisplay(false), which sets the display state to false, prompting a rerender and hiding the submission box
  }

  return (
    <ModalDisplay display={displayValue}>
      <Div margin={tenzero}>
        <div style={iconContainerStyle}>
          <CheckCircleIcon style={successIconStyle} />
        </div>
        <Div margin={tenzero}>
          <Typography
            fontWeight={"bold"}
            color={"rgb(33, 42, 65)"}
            style={{ fontSize: "1.25rem", textAlign: "center" }}
          >
            Submit Test
          </Typography>
        </Div>
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          Are you sure you want to submit your test?
        </Text>
      </Div>
      <Div
        margin={tenzero}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <ModalButton onClick={clickNoHandler}>Cancel</ModalButton>
        <ModalButton onClick={props.handler2}>Confirm</ModalButton>
      </Div>
    </ModalDisplay>
  );
}

const iconContainerStyle = {
  display: "flex",
  width: "fit-content",
  justifyContent: "center",
  marginBottom: "15px",
  backgroundColor: "rgb(33, 42, 65, 0.3)",
  borderRadius: "20%",
  padding: "10px",
  margin: "0 auto",
};

const successIconStyle = {
  color: "rgb(33, 42, 65)",
  fontSize: "2rem",
};
